const JobTypes = {
  IMPORT: 13,
  EXPORT: 30,
  GEOBUFFER_LINK_DATASET_TO_GEOGRAPHY_AND_CREATE_DATA_TILE_LAYER: 15,
  GEOBUFFER_UNLINK_DATASET_FROM_GEOGRAPHY_AND_REMOVE_DATA_TILE_LAYER: 36,
  GEOBUFFER_CREATE_NEW_FROM_EXISTING_DATASET: 16,
  GEOBUFFER_BULK_CREATE_NEW_FROM_EXISTING_DATASET: 17,
  GEOBUFFER_VERTICAL_MERGE: 18,
  IMPORT_COLUMNS: 35,
  GEOBUFFER_CREATE_GEO_FROM_COORDINATES: 25,
  GEOBUFFER_SPATIAL_JOIN: 51,
  GEOBUFFER_CREATE_COLUMNS_PROPERTIES: 26,
  GEOBUFFER_UPDATE_TILES_FOR_LINKED_DATASET: 72,
  GEOBUFFER_CREATE_GEO_TILE_LAYER: 20,
  GEOBUFFER_DELETE_PROJECTION: 27,
  GEOBUFFER_BULK_DELETE_DATASETS_AND_REMOVE_GEO: 61,
  GEOBUFFER_HARD_DELETE_DATASET: 73,
  GEOBUFFER_BULK_HARD_DELETE_DATASETS: 74,
  GEOBUFFER_UPDATE_TILES_FOR_DEFAULT_AND_LINKED_DATASETS: 71,
  GEOBUFFER_IMPORT_GEOGRAPHY_TO_DATASET_AND_CREATE_GEO_TILE_LAYER: 80,
  GEOBUFFER_CREATE_LAT_LONG_COLUMNS: 81,

  GEOBUFFER_FLATTEN_DATASET: 66,
  GEOBUFFER_GEOCODE: 67,
  GEOBUFFER_CHANGE_OWNERSHIP: 68,
  GEOBUFFER_DISSOLVE_GEO: 75,
  GEOBUFFER_IMPORT_GEOSERVICES_LAYER: 14,
  GEOBUFFER_IMPORT_GEOSERVICES_DATASET: 12,
  GEOBUFFER_CREATE_DATASET_VERSION: 82,
  GEOBUFFER_REMOVE_GEOGRAPHY_FROM_DEFAULT_DATASETS: 84,
  GEOBUFFER_COMBINE_COLUMNS: 89,
  GEOBUFFER_SPLIT_COLUMN: 111,
  GEOBUFFER_PERFORM_STRING_COLUMN_OPERATION: 112,
  GEOBUFFER_CONVERT_GEOGRAPHY_TYPE: 115,
  GEOBUFFER_PERFORM_UNARY_GEOSPATIAL_OPERATION: 116,
  GEOBUFFER_TAG_OPERATIONS: 117,
  GEOBUFFER_DUPLICATE_COLUMN: 118,
  GEOBUFFER_PERFORM_GEOSPATIAL_OPERATION: 123,
  GEOBUFFER_CREATE_COLUMN: 124,
  GEOBUFFER_UPDATE_COLUMN: 125,
  GEOBUFFER_SWAP_LINKED_DATASETS_DATA_TILE_LAYER_IDS: 126,
  GEOBUFFER_IMPORT_SE_DATA_FOR_GEOGRAPHY: 127,
  GEOBUFFER_REFRESH_DATASET_ORIGINATING_FROM_SE: 128,
  GEOBUFFER_GEOCODE_USING_HERE_GEOCODER: 129,
  GEOBUFFER_PUBLISH_DATASET_ARTIFACTS: 137,

  GEOBUFFER_UNLOAD_DATASET: 130,
  GEOBUFFER_LOAD_DATASET: 131,
  GEOBUFFER_UNLOAD_COLLECTION: 132,
  GEOBUFFER_LOAD_COLLECTION: 133,

  GEOBUFFER_DELETE_TEAM: 113,

  GEOBUFFER_GENERATE_GEORECORD_SEARCH_INDEX: 134,

  // job types that do not exist on backend
  UPLOAD_DATASET: -2,
  UPLOAD_ATTACHMENT: -6,
  IMPORT_ATTACHMENT: -3,
  DELETE_ATTACHMENT: -4,
  RESTORE_DATASET: -5,
  DELETE_DATASET_VERSION: -7,
};

export default JobTypes;
